import initHeader from "./layout/header.js";

jQuery(document).ready(function ($) {
    initHeader();


    const headerOffset = document.querySelector("header").offsetHeight;
    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            const href = this.getAttribute("href");
            const currentUrl = window.location.origin + window.location.pathname;

            // Ištraukiam tik fragmentą po #
            const hashIndex = href.indexOf("#");
            const targetId = hashIndex !== -1 ? href.slice(hashIndex + 1) : null;

            // Patikrinam ar nuoroda veda į tą patį puslapį
            let isSamePage = false;

            if (href.startsWith("#")) {
                // Tiesioginis fragmentas: #uzklausa
                isSamePage = true;
            } else if (href.startsWith(currentUrl + "#")) {
                // Pilnas URL su fragmentu: https://example.com/vertimai/#uzklausa
                isSamePage = true;
            } else if (href.startsWith(window.location.pathname + "#")) {
                // Santykinis kelias su fragmentu: /vertimai/#uzklausa
                isSamePage = true;
            }

            // Toliau vykdom tik jei ID yra ir nuoroda veda į tą patį puslapį
            if (targetId && isSamePage) {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    e.preventDefault();
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            }
        });
    });

// NEW: Handle hash fragments when page loads (for cross-page navigation)
    function handleHashOnLoad() {
        const hash = window.location.hash;
        if (hash) {
            const targetId = hash.slice(1); // Remove the # symbol
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Small delay to ensure page is fully rendered
                setTimeout(() => {
                    const headerOffset = document.querySelector("header")?.offsetHeight || 0;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }, 100); // 100ms delay
            }
        }
    }

// Run when DOM is loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleHashOnLoad);
    } else {
        // DOM already loaded
        handleHashOnLoad();
    }

// Also handle browser back/forward navigation with hash changes
    window.addEventListener('hashchange', handleHashOnLoad);



    if (document.querySelector('.with-tooltip')) {
        tippy('[data-tippy-content]', {
            theme: 'tomato',
            onShow(instance) {
                const referenceWidth = instance.reference.offsetWidth;
                const box = instance.popper.querySelector('.tippy-box');
                box.style.width = referenceWidth + 'px';
            }
        });
    }

    /*newsletter*/
    function handleMailerLiteFormSubmission(formId, successSelector) {
        $(formId).on('submit', function (event) {
            event.preventDefault();
            var formData = $(this).serialize();
            const url = 'https://assets.mailerlite.com/jsonp/729053/forms/122575638866429168/subscribe';

            $.ajax({
                url: url,
                type: 'POST',
                data: formData,
                dataType: 'jsonp',
                success: function (response) {
                    if (response && response.success) {
                        $(successSelector).show();
                        $(formId).hide();
                    } else {
                        alert('There was an error submitting the form. Please try again.');
                    }
                },
                error: function () {
                    alert('There was an error submitting the form. Please try again.');
                }
            });
        });
    }

    // Call the function for each form with appropriate selectors
    handleMailerLiteFormSubmission('#newsletter-form', '.ml-form-successBody');
    /*newsletter*/

    /*button dropdown*/
    document.addEventListener('click', function(e) {
        const toggle = e.target.closest('a[class*="dropdown-toggle"]');
        const isDropdownItem = e.target.closest('.dropdown-menu a');
        const openWrapper = document.querySelector('.btn-dropdown-wrapper.open');

        if (toggle) {
            e.preventDefault();
            const wrapper = toggle.closest('.btn-dropdown-wrapper');
            if (!wrapper) return;

            // Toggle clicked dropdown
            wrapper.classList.toggle('open');

            // Close others
            document.querySelectorAll('.btn-dropdown-wrapper.open').forEach(other => {
                if (other !== wrapper) other.classList.remove('open');
            });
            return;
        }

        // Close dropdown if clicking on any dropdown menu item
        if (isDropdownItem && openWrapper) {
            openWrapper.classList.remove('open');
            return;
        }

        // Close dropdown if clicking outside any open dropdown
        if (openWrapper && !e.target.closest('.btn-dropdown-wrapper.open')) {
            openWrapper.classList.remove('open');
        }
    });

    /*button dropdown*/

});

